import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker for PWA support ONLY in production builds.
// In development (CRA dev server) there is no /service-worker.js, so the
// localhost check in serviceWorkerRegistration would find a stale SW from a
// previous prod build and unregister()+reload() in an infinite loop — which
// makes the login page auto-refresh. In dev we actively unregister instead.
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      // New version available — activate it and refresh once.
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    },
  });
} else {
  serviceWorkerRegistration.unregister();
}

reportWebVitals();
